export default __webpack_public_path__ + "static/media/checkmark.1f6b6796.svg";